export default "__VITE_ASSET__dba9beba__"